import TypesenseInstantSearchAdapter from 'typesense-instantsearch-adapter';
import config from '../config';

let typesenseAdapter;

export const initializeTypesense = async () => {
  console.log('[Typesense] Initializing Typesense Adapter');

  typesenseAdapter = new TypesenseInstantSearchAdapter({
    server: {
      apiKey: config.TYPESENSE_API_KEY, // API key for Typesense
      nodes: [
        {
          host: '5wcsfbzrto7vhixkp-1.a1.typesense.net',
          port: '443',
          protocol: 'https'
        }
      ],
      cacheSearchResultsForSeconds: 2 * 60 // Cache search results for 2 minutes
    },
    collectionSpecificSearchParameters: {
      /**
       * Collection query parameters should be defined here. As well as the fields that are to be displayed in the search results.
       *
       * Avoid including fields that are not used in the search results, as this will increase the size of the search results for no purpose and cost more money.
       *
       * infix must be set to 'off' for all fields except the one that is used for searching defined in the collection schema
       */
      purchases: {
        queryBy: 'uuid, customer_first_name, customer_last_name, customer_email, customer_phone',
        infix: 'off, off, off, always, always',
        includeFields:
          'rafflebox_id, created_at, uuid, goldrush_subscription_id, customer_first_name, customer_last_name, customer_email, customer_phone, total_amount_cents, payment_status_id',
        facetBy: 'payment_status_id, batch_id, device_id'
      }
    }
  });
  console.log('[Typesense] Adapter initialized');
};

export { typesenseAdapter };
